module.exports = "label1: \nj label4\n\nlabel3:\njal label5\n\nlabel4:\nbeq $zero, $t0, label4\nnop\nbeq $zero, $zero, label3\nnop\n\nlabel5:\njr $ra\n\n"